import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { connect } from "react-redux"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { withTranslation } from "react-i18next"
import "flatpickr/dist/themes/material_blue.css"
import SettingSidebar from "../../../components/VerticalLayout/SettingSidebar";
import Switch from "react-switch"
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    FormGroup,
    Label,
} from "reactstrap"
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import GeneralSettingMenu from "../menu/general-setting-menu";
import UpdateButton from "components/buttons/updateBtn";
import ProfileSidebar from "components/VerticalLayout/profileSidebar";
import SafeField from "helpers/SafeField";
import { API_URL } from "helpers/app_url";
import Cookies from "js-cookie";
import axios from "axios";
class GenralSecurity extends Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }
    handleSubmit = (values, actions) => {
         toast.loading("Please wait...");
         const payload = {
           userName: Cookies.get("rs_userName") || "",
           oldPassword: Cookies.get("rs_password") || "",
           password: values.password
        }
         const obj = JSON.parse(localStorage.getItem("authUser"));
         const token = obj.resultData.bearerToken;
         const str = 'Bearer ' + token;
         var authOptions = {
           method: 'post',
           url: `${API_URL}user/changepassword`,
           data: payload,
           headers: { Authorization: str }
         };
     
         axios(authOptions)
           .then((response) => {
             if (response.data.success) {
               toast.dismiss();
               toast.success("Saved successfully");
             }
             else {
               toast.dismiss();
               toast.success(response.data.validationErrors[0]);
              
             }
           })
           .catch((error) => {
             toast.dismiss();
             toast.success("Error" + error);
           })
       } 
    render() {
        const Offsymbol = () => {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  fontSize: 12,
                  color: "#fff",
                  paddingRight: 2
                }}
              >
                {" "}
                No
              </div>
            )
          }
      
          const OnSymbol = props => {
            return (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  fontSize: 12,
                  color: "#fff",
                  paddingRight: 2
                }}
              >
                {" "}
                Yes
              </div>
            )
          }
        return (
            <React.Fragment>
                <div className="page-content">
                    <MetaTags>
                        <title>General Setting Security | Realty Space</title>
                    </MetaTags>
                    <Container fluid>
                        <ToastContainer autoClose={2000} />
                        <Row className="mb20">
                            <Col xl="6">
                                <Breadcrumbs
                                    title={this.props.t("Agent")}
                                    breadcrumbItem={this.props.t("General Settings")}
                                />
                            </Col>
                        </Row>
                        <Row>
                            <Col xl="3">
                                <ProfileSidebar />
                            </Col>
                            <Col xl="9">
                              
                               <Formik
  enableReinitialize={true}
  initialValues={{
    password: "",
    confirmPassword: "",
  }}
              validationSchema={Yup.object().shape({
                password: Yup.string()
                  .required("Password is required")
                  .min(12, "Password must be at least 12 characters")
                  .matches(
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^()\-_=+{}[\]|\\:;'"<>,./]).{8,}$/,
                    "Must contain uppercase, lowercase, number and special character"
                  ),
                confirmPassword: Yup.string()
                  .required("Confirm password is required")
                  .oneOf([Yup.ref("password")], "Passwords must match"),
              })}
              onSubmit={this.handleSubmit}
            >
  {({ errors, touched, values, handleChange, setFieldValue }) => (
    <Form className="needs-validation">
      <Card className="border-full">
        <CardBody>
          <h5 className="card-title">Password Update</h5>

          <Row>
            <Col sm="3">
              <FormGroup className="mb-3">
                <Label htmlFor="password">
                  {this.props.t("New Password")}
                </Label>
                <SafeField
                  name="password"
                  onChange={handleChange}
                  type="password"   // better than "text"
                  className={
                    "form-control" +
                    (errors.password && touched.password ? " is-invalid" : "")
                  }
                  id="password"
                />
                <ErrorMessage
                  name="password"
                  component="div"
                  className="invalid-feedback"
                />
              </FormGroup>
            </Col>

            <Col sm="3">
              <FormGroup className="mb-3">
                <Label htmlFor="confirmPassword">
                  {this.props.t("Confirm Password")}
                </Label>
                <SafeField
                  name="confirmPassword"
                  onChange={handleChange}
                  type="password"
                  className={
                    "form-control" +
                    (errors.confirmPassword && touched.confirmPassword
                      ? " is-invalid"
                      : "")
                  }
                  id="confirmPassword"
                />
                <ErrorMessage
                  name="confirmPassword"
                  component="div"
                  className="invalid-feedback"
                />
              </FormGroup>
            </Col>

            <Col sm="2">
              <UpdateButton btnClass="mt-27">Update</UpdateButton>
            </Col>
          </Row>
        </CardBody>
      </Card>

     
      <Card className="border-full">
        <CardBody>
          <h5 className="card-title">Security</h5>
          <Row>
            <Col sm="12">
              <FormGroup className="mb-3 float-left">
                <Label htmlFor="contactFName">
                  {this.props.t("Enable 2 factor authentication")}
                </Label>
                <Switch
                  uncheckedIcon={<Offsymbol />}
                  className="me-1 mb-sm-8 mb-2 float-end"
                  checkedIcon={<OnSymbol />}
                  onColor="#626ed4"
                  onChange={() =>
                    this.setState({ switch1: !this.state.switch1 })
                  }
                  checked={this.state.switch1}
                />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Form>
  )}
</Formik>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        )
    }
}
GenralSecurity.propTypes = {
    t: PropTypes.any,
    history: PropTypes.object,
    match: PropTypes.object,
}
const mapStateToProps = () => (
    {
    })
const mapDispatchToProps = dispatch => ({
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GenralSecurity))
